export class Tabs
{
    constructor()
    {
        this.tabs = document.querySelectorAll('*[tab-filter]')
        this.reset(true)

        this.tabs.forEach(t => {
            const endpoint = t.getAttribute('tab-filter')
            const endpointEL = document.querySelector(endpoint)

            t.addEventListener('click', e => {
                e.preventDefault()
                this.reset()
                
                t.classList.add('active')
                
                if (endpointEL) {
                    endpointEL.style.display = 'block';
                }
            })
        })
    }

    reset(isInit = false)
    {
        this.tabs.forEach(t => {
            const endpoint = t.getAttribute('tab-filter')
            const endpointEL = document.querySelector(endpoint)

            if (!(isInit && t.classList.contains('active'))) {
                t.classList.remove('active')
                
                if (endpointEL) {
                    endpointEL.style.display = 'none';
                }
            }
        })
    }
}
